'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { initializeXSiteNavigation } from '@/lib/xsite-navigation';

export function XSiteNavigationProvider({ children }) {
  const router = useRouter();
  
  useEffect(() => {
    // Initialisiere XSite Navigation Manager global mit Next.js Router
    initializeXSiteNavigation(router);
    
    return () => {
    };
  }, [router]);

  return children;
} 